import { memo, useCallback } from 'react';

import { LibraryInviteMemberChip } from '~/components/LibraryBeta/LibraryInviteMember/components/LibraryInviteMemberChip';
import { type LibraryInviteMemberChipType } from '~/components/LibraryBeta/LibraryInviteMember/LibraryInviteMember';

export type LibraryInviteMemberRemovableChipProps = {
  member: LibraryInviteMemberChipType;
  onRemove: (email: string) => void;
};

export const LibraryInviteMemberRemovableChip = memo(({ member, onRemove }: LibraryInviteMemberRemovableChipProps) => {
  const handleRemoveClick = useCallback(() => {
    onRemove(member.email);
  }, [member.email, onRemove]);

  return (
    <LibraryInviteMemberChip
      avatar={member.avatar ?? undefined}
      colorSeed={member.accountId ?? undefined}
      label={member.label || member.email}
      onRemoveClick={handleRemoveClick}
    />
  );
});

LibraryInviteMemberRemovableChip.displayName = 'LibraryInviteMemberRemovableChip';
